export default function generateMetaDescription (siteOptions, page) {
  if (siteOptions.default_meta_description) {
    let description = {
      metaDescription: siteOptions.default_meta_description,
      ogDescription: siteOptions.default_meta_description
    }

    // Check for SEO meta description
    if (page.seo_enabled) {
      // console.log('SEO enabled')
      page.meta_description
      ? description = {
        metaDescription: page.meta_description,
        ogDescription: page.meta_description
      }
      : null
    }

    // Check for OG description
    if (page.og_enabled) {
      // console.log('OG enabled')
      page.og_description
      ? description.ogDescription = page.og_description
      : null
    }

    return description
  }
}



// WEBPACK FOOTER //
// ./client/common/generateMetaDescription.js